import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { authV2Messages } from '../components/authV2Messages';
import styles from './TurnstileSlot.module.scss';

interface TurnstileSlotProps {
  slotRef: (element: HTMLElement | null) => void;
  isVisible: boolean;
  /** The widget asks the person to tick the box and has no token yet (`useTurnstile`). */
  needsInteraction?: boolean;
}

/**
 * The place of the Turnstile widget on the email-code step. It stays collapsed while the check
 * runs unseen, and opens only when Cloudflare shows an interactive check. While that check waits
 * for the person, a hint under it says what to do.
 */
const TurnstileSlotComponent: React.FC<TurnstileSlotProps> = ({ slotRef, isVisible, needsInteraction = false }) => {
  const intl = useIntl();
  return (
    <>
      <div
        ref={slotRef}
        className={isVisible ? styles.visible : styles.slot}
        data-testid="turnstile-slot"
        aria-hidden={!isVisible}
      />
      {needsInteraction ? (
        <p className="au-small" role="status" data-testid="turnstile-hint">
          {intl.formatMessage(authV2Messages.securityCheckTick)}
        </p>
      ) : null}
    </>
  );
};

export const TurnstileSlot = TypedMemo(TurnstileSlotComponent);
